"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Asteroids = void 0;
function Asteroids() {
    var s = document.createElement('script');
    document.body.appendChild(s);
    s.src = '/js/asteroids.min.js';
}
exports.Asteroids = Asteroids;
